const sharedStyle = {
  'font-weight': '500',
  padding: '3px 6px',
  'border-radius': '6px',
  'margin-top': '2px'
}
const styles = {
  trace: { color: '#620981', background: '#f3daff', ...sharedStyle },
  debug: { color: '#238a4b', background: '#dbffe6', ...sharedStyle },
  info: { color: '#2875bc', background: '#daebff', ...sharedStyle },
  log: { color: '#282828', background: '#dcdcdc', ...sharedStyle },
  warn: { color: '#ff6f25', background: '#ffe2d6', ...sharedStyle },
  error: { color: '#dc143b', background: '#ffd5de', ...sharedStyle },
}

const getStyledPrefix = (styleName, text) => (styles[styleName]
  ? [`%c${text}`, Object.entries(styles[styleName] || {}).map(([k, v]) => `${k}:${v}`).join(';')]
  : [])

const consoleMethods = [
  'trace',
  'debug',
  'info',
  'log',
  'warn',
  'error',
  'table',
  'group',
  'groupEnd'
]

// Using class in case of several instance
// Binding real console methods in non-silent mode to real console, so it gets original stack trace, and exposing these methods via the instance
// Still defining instance methods (for completion and for doing no-op)
class Logger {
  constructor(name, {
    prefix = '',
    silent = false,
    styled = true
  }) {
    this.name = name
    this.prefix = prefix ? `[YOTI ${prefix}]` : ''

    if (console && !silent) {
      consoleMethods.forEach((method) => {
        const styledPrefix = styled ? getStyledPrefix(method, this.prefix) : [this.prefix]
        // eslint-disable-next-line no-console
        this[`${method}`] = console[method].bind(console, ...styledPrefix)
      })
    }
  }

  // eslint-disable-next-line class-methods-use-this,no-unused-vars
  trace(...args) {}

  // eslint-disable-next-line class-methods-use-this,no-unused-vars
  info(...args) {}

  // eslint-disable-next-line class-methods-use-this,no-unused-vars
  debug(...args) {}

  // eslint-disable-next-line class-methods-use-this,no-unused-vars
  log(...args) {}

  // eslint-disable-next-line class-methods-use-this,no-unused-vars
  warn(...args) {}

  // eslint-disable-next-line class-methods-use-this,no-unused-vars
  error(...args) {}

  // eslint-disable-next-line class-methods-use-this,no-unused-vars
  table(...args) {}

  // eslint-disable-next-line class-methods-use-this,no-unused-vars
  group(...args) {}

  // eslint-disable-next-line class-methods-use-this,no-unused-vars
  groupEnd(...args) {}
}
export default Logger
